'use client'

import React from 'react'
import { useTranslations } from 'next-intl'

import type { HolidaySection } from '@/src/types/holidays'

import PackageInclusions, { type InclusionTab } from './packageInclusions'

interface PackageInclusionsWrapperProps {
    /** The `inclusions` and `exclusions` sections, in document order. */
    sections: HolidaySection[]
    isMobile: boolean
}

const PackageInclusionsWrapper: React.FC<PackageInclusionsWrapperProps> = ({ sections, isMobile }) => {
    const t = useTranslations('holidaysPage')

    const tabs: InclusionTab[] = []
    for (const section of sections) {
        if (section.type !== 'bulletList' || !section.items?.length) continue
        // The API's own ids, not the copy: a package may title its exclusions anything.
        const id = section.id === 'exclusions' ? 'excluded' : 'included'
        tabs.push({
            id,
            label: id === 'included' ? t('inclusionsIncluded') : t('inclusionsNotIncluded'),
            items: section.items
        })
    }

    if (!tabs.length) return null

    return (
        <PackageInclusions
            tabs={tabs}
            showAllLabel={count => t('inclusionsShowAll', { count })}
            showLessLabel={t('listShowLess')}
            isMobile={isMobile}
        />
    )
}

export { PackageInclusionsWrapper }
export default PackageInclusionsWrapper
